module.exports = __webpack_public_path__ + "static/media/h-square.358ca71a.svg";